import { z } from "zod";

const bulkEventTypeSchema = z.enum(["injection", "shockwave", "surgery", "education", "product", "medication"]);

/** Shared search for /patients/bulk/* screens - selected diary IDs in the URL. */
export const bulkDiaryIdsSearchSchema = z.object({
    diaryIds: z
        .union([z.array(z.string().uuid()), z.string().uuid()])
        .optional()
        .transform((value) => {
            if (!value) return [] as string[];
            return Array.isArray(value) ? value : [value];
        })
        .pipe(z.array(z.string().uuid())),
    eventType: bulkEventTypeSchema.optional(),
});

export type BulkDiaryIdsSearch = z.infer<typeof bulkDiaryIdsSearchSchema>;

/** Parse diaryIds and keep other search keys (list filters) on the URL. */
export function parseBulkDiaryIdsSearch(search: Record<string, unknown>): BulkDiaryIdsSearch & Record<string, unknown> {
    const parsed = bulkDiaryIdsSearchSchema.parse(search);
    return { ...search, ...parsed };
}

/** Drop bulk-only keys when returning to /patients. */
export function withoutBulkDiaryIdsSearch(search: Record<string, unknown>): Record<string, unknown> {
    const { diaryIds: _diaryIds, eventType: _eventType, ...rest } = search;
    return rest;
}
